let sliderSplideInit;
document.addEventListener('DOMContentLoaded', () => {
    if (!sliderSplideInit) {
        document.querySelectorAll('.slider-splide').forEach((element) => {
            // eslint-disable-next-line no-undef
            new Splide(element).mount();
        });
        sliderSplideInit = true;
    }
});
